import React from 'react';
import { Navigate } from 'react-router-dom';

// Componente para proteger rutas según el rol
function ProtectedRoute({ children, allowedRoles }) {
  const userRol = localStorage.getItem('rol');

  // Si no hay usuario logueado
  if (!userRol) {
    return <Navigate to="/" />;
  }

  // Si el rol no está permitido
  if (!allowedRoles.includes(userRol)) {
    return <Navigate to="/dashboard" />;
  }

  // Si el rol es permitido, mostramos la ruta
  return children;
}

export default ProtectedRoute;
